export const routingReservedKeywords: readonly string[] = [
    'stammdaten',
    'orders',
    'weighing',
    'scales',
    'settings',
    'billing',
    'permissions',
    'profile',
    'login',
];
